import React from 'react';
import PropTypes from 'prop-types';

import { Box, Text } from 'grommet';


const ProductRowStats = ({
  small, label, color, stat = null, isLast = false,
}) => (
  <Box
    pad={{ horizontal: '0.65rem' }}
    border={!isLast && { color: 'var(--nav-border)', style: 'solid', side: 'right' }}
  >
    <Text
      uppercase
      weight={600}
      size={small ? '0.85rem' : '1rem'}
      color={color}
      style={{ letterSpacing: '0.216px' }}
    >
      {label}
      &nbsp;
      {stat || '0'}
    </Text>
  </Box>
);

ProductRowStats.propTypes = {
  small: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  stat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
};

export default ProductRowStats;
